"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WordRandomiser = void 0;
var WordRandomiser = /** @class */ (function () {
    function WordRandomiser() {
    }
    WordRandomiser.prototype.getRandomisedLettersByWord = function (word) {
        return this.generateRandomOrder(word);
    };
    WordRandomiser.prototype.generateRandomOrder = function (word) {
        var reorderedWord = "";
        var wordRandomOrder = this.shuffle(word.split(""));
        for (var i = 0; i < wordRandomOrder.length; i++) {
            var letter = wordRandomOrder[i];
            reorderedWord += letter;
        }
        return reorderedWord;
    };
    WordRandomiser.prototype.shuffle = function (array) {
        var currentIndex = array.length, temporaryValue, randomIndex;
        // While there remain elements to shuffle...
        while (0 !== currentIndex) {
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;
            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }
        return array;
    };
    return WordRandomiser;
}());
exports.WordRandomiser = WordRandomiser;
